import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "modal-title" };
const _hoisted_3 = { class: "modal-body" };
const _hoisted_4 = { class: "product-info" };
const _hoisted_5 = { class: "product-image" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "product-details" };
const _hoisted_8 = { class: "product-name" };
const _hoisted_9 = { class: "product-description" };
const _hoisted_10 = { class: "options-section" };
const _hoisted_11 = { class: "options-description" };
const _hoisted_12 = { class: "parmesan-option" };
const _hoisted_13 = { class: "supplement-image" };
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = { class: "supplement-info" };
const _hoisted_16 = { class: "supplement-name" };
const _hoisted_17 = { class: "supplement-price" };
const _hoisted_18 = { class: "supplement-checkbox" };
const _hoisted_19 = { class: "quantity-section" };
const _hoisted_20 = { class: "quantity-label" };
const _hoisted_21 = { class: "quantity-controls" };
const _hoisted_22 = ["disabled"];
const _hoisted_23 = { class: "quantity-display" };
const _hoisted_24 = { class: "modal-footer" };
const _hoisted_25 = { class: "total-price" };
const _hoisted_26 = { class: "price-value" };
const _hoisted_27 = { class: "action-buttons" };
import { ref } from 'vue';
import htmlToText from '@/utils/html-to-text';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PastaCustomizationModal',
    props: {
        product: {},
        selectedSize: {}
    },
    emits: ["close", "add-to-cart"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const props = __props;
        const emit = __emit;
        const parmesanSupplement = {
            id: "parmesan",
            name: "Parmesan",
            price: 1.0,
            extra_cost_price: 1.0,
            image_url: "/images/supplements/default-parmesan.png",
            quantity: 0,
            type: "pasta",
            size: "Normale",
            isDefault: false,
            isAvailable: true
        };
        const withParmesan = ref(false);
        const quantity = ref(1);
        const formatPrice = (price) => {
            return `${price.toFixed(2)} CHF`;
        };
        const toggleParmesan = () => {
            withParmesan.value = !withParmesan.value;
        };
        const incrementQuantity = () => {
            quantity.value++;
        };
        const decrementQuantity = () => {
            if (quantity.value > 1) {
                quantity.value--;
            }
        };
        const calculateTotal = () => {
            if (!props.selectedSize)
                return 0;
            const isDelivery = store.getters['orderType/isDelivery'];
            const basePrice = isDelivery && props.selectedSize.priceLivraison
                ? parseFloat(props.selectedSize.priceLivraison) || 0
                : parseFloat(props.selectedSize.price) || 0;
            const parmesanPrice = withParmesan.value ? parmesanSupplement.extra_cost_price : 0;
            return (basePrice + parmesanPrice) * quantity.value;
        };
        const closeModal = () => {
            withParmesan.value = false;
            quantity.value = 1;
            emit('close');
        };
        const handleAddToCart = () => {
            if (!props.product || !props.selectedSize)
                return;
            if (withParmesan.value) {
                store.dispatch('features/toggleFeature', parmesanSupplement.name);
            }
            const sizeWithOriginalPrices = {
                ...props.selectedSize,
                price: props.selectedSize.price,
                priceLivraison: props.selectedSize.priceLivraison
            };
            const selectedSupplements = withParmesan.value ? [{
                    id: parmesanSupplement.id,
                    name: parmesanSupplement.name,
                    extra_cost_price: parmesanSupplement.extra_cost_price,
                    quantity: 1,
                    type: parmesanSupplement.type,
                    size: parmesanSupplement.size
                }] : [];
            const cartIngredients = (props.product.ingredients || []).map(ing => ({
                id: ing.id,
                name: ing.name,
                extra_cost_price: ing.price || 0,
                quantity: ing.isDefault ? 1 : 0,
                isDefault: ing.isDefault,
                size: props.selectedSize?.name || props.selectedSize?.size || ''
            }));
            const event = {
                product: props.product,
                size: sizeWithOriginalPrices,
                quantity: quantity.value,
                ingredients: cartIngredients,
                supplements: selectedSupplements,
                notes: ''
            };
            emit('add-to-cart', event);
            closeModal();
        };
        return (_ctx, _cache) => {
            return (__props.product)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: closeModal
                }, [
                    _createElementVNode("div", {
                        class: "modal-content",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('pos.customizePasta')), 1),
                            _createElementVNode("button", {
                                onClick: closeModal,
                                class: "close-button"
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        src: __props.product.image || '/imgs/pasta-placeholder.jpg',
                                        alt: __props.product.name,
                                        class: "product-img"
                                    }, null, 8, _hoisted_6)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.product.name), 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(htmlToText)(__props.product.description || '')), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('pos.addParmesanDescription')), 1),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["supplement-card", { 'selected': withParmesan.value }]),
                                        onClick: toggleParmesan
                                    }, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("img", {
                                                src: parmesanSupplement.image_url,
                                                alt: parmesanSupplement.name,
                                                class: "supplement-img"
                                            }, null, 8, _hoisted_14)
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(parmesanSupplement.name), 1),
                                            _createElementVNode("span", _hoisted_17, "+" + _toDisplayString(formatPrice(parmesanSupplement.extra_cost_price)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(withParmesan.value ? 'fas fa-check-circle' : 'far fa-circle')
                                            }, null, 2)
                                        ])
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.quantity')) + " :", 1),
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("button", {
                                        onClick: decrementQuantity,
                                        disabled: quantity.value <= 1,
                                        class: "quantity-btn"
                                    }, " ➖ ", 8, _hoisted_22),
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(quantity.value), 1),
                                    _createElementVNode("button", {
                                        onClick: incrementQuantity,
                                        class: "quantity-btn"
                                    }, " ➕ ")
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "price-label" }, "Total :", -1)),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(formatPrice(calculateTotal())), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                    onClick: closeModal,
                                    class: "cancel-btn"
                                }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                                _createElementVNode("button", {
                                    onClick: handleAddToCart,
                                    class: "add-to-cart-btn"
                                }, [
                                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.addToCart')), 1)
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
